/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running a full 60-minute deep-work block on one task with no interruptions.`)
};

const es_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizar un bloque completo de trabajo profundo de 60 minutos en una tarea sin interrupciones.`)
};

const de_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen vollen 60-minütigen Deep-Work-Block an einer Aufgabe ohne Unterbrechungen absolvieren.`)
};

const nl_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een volledig deep-work-blok van 60 minuten draaien op één taak zonder onderbrekingen.`)
};

const fr_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effectuer un bloc complet de 60 minutes de travail en profondeur sur une tâche, sans interruptions.`)
};

const it_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare un blocco completo di deep work di 60 minuti su un solo compito senza interruzioni.`)
};

const pt_br2_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um bloco completo de trabalho profundo de 60 minutos em uma tarefa, sem interrupções.`)
};

const pt_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um bloco completo de trabalho profundo de 60 minutos numa tarefa, sem interrupções.`)
};

const ja_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中断なしで1つのタスクに丸60分間のディープワークブロックを行う。`)
};

const zh_timer_u1h_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`针对一项任务进行完整60分钟、不受打扰的深度工作时段。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1h_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1h_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1h_use1", locale)
	if (locale === "en") return en_timer_u1h_use1(inputs)
	if (locale === "es") return es_timer_u1h_use1(inputs)
	if (locale === "de") return de_timer_u1h_use1(inputs)
	if (locale === "nl") return nl_timer_u1h_use1(inputs)
	if (locale === "fr") return fr_timer_u1h_use1(inputs)
	if (locale === "it") return it_timer_u1h_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1h_use1(inputs)
	if (locale === "pt") return pt_timer_u1h_use1(inputs)
	if (locale === "ja") return ja_timer_u1h_use1(inputs)
	return zh_timer_u1h_use1(inputs)
};